import { useEffect, useRef } from "react";
import { FAQ_ICONS } from "@/components/faq/faqIcons";

export function FaqSidebar({ categories, counts, activeId, onJump }) {
  return (
    <nav aria-label="Categorías de preguntas frecuentes" data-testid="faq-sidebar" className="hidden lg:block lg:sticky lg:top-28">
      <p className="text-xs font-bold tracking-[0.22em] uppercase text-navy-800">Temas</p>
      <ul className="mt-4 space-y-1">
        {categories.map((c) => {
          const Icon = FAQ_ICONS[c.icon];
          const active = activeId === c.id;
          const n = counts[c.id];
          return (
            <li key={c.id}>
              <a
                href={`#cat-${c.id}`}
                onClick={(e) => onJump(e, c.id)}
                data-testid={`faq-sidebar-link-${c.id}`}
                aria-current={active ? "true" : undefined}
                className={`flex items-center gap-3 rounded-lg border-l-2 px-3 py-2.5 text-sm transition-colors ${
                  active
                    ? "border-[#F26522] bg-[#FEF3EB] font-bold text-navy-800"
                    : "border-transparent text-slate-600 hover:bg-slate-50 hover:text-navy-800"
                } ${n === 0 ? "opacity-40" : ""}`}
              >
                <Icon className={`h-4 w-4 shrink-0 ${active ? "text-[#F26522]" : "text-slate-400"}`} strokeWidth={1.8} />
                <span className="flex-1 leading-snug">{c.short}</span>
                <span className="text-xs tabular-nums text-slate-400">{n}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export function FaqChips({ categories, counts, activeId, onJump }) {
  const barRef = useRef(null);

  useEffect(() => {
    const bar = barRef.current;
    const chip = bar?.querySelector(`[data-chip="${activeId}"]`);
    if (bar && chip) bar.scrollTo({ left: chip.offsetLeft - 16, behavior: "smooth" });
  }, [activeId]);

  return (
    <nav
      aria-label="Categorías de preguntas frecuentes"
      data-testid="faq-chips"
      className="lg:hidden sticky top-[60px] z-30 -mx-5 sm:-mx-6 border-b border-slate-200 bg-white/95 backdrop-blur"
    >
      <div ref={barRef} className="flex gap-2 overflow-x-auto px-5 sm:px-6 py-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {categories.map((c) => {
          const active = activeId === c.id;
          return (
            <a
              key={c.id}
              href={`#cat-${c.id}`}
              data-chip={c.id}
              onClick={(e) => onJump(e, c.id)}
              data-testid={`faq-chip-${c.id}`}
              aria-current={active ? "true" : undefined}
              className={`shrink-0 whitespace-nowrap rounded-full border px-3.5 py-1.5 text-xs font-bold transition-colors ${
                active
                  ? "border-[#F26522] bg-[#F26522] text-white"
                  : "border-slate-200 bg-white text-slate-600 hover:border-[#F26522]/50"
              } ${counts[c.id] === 0 ? "opacity-40" : ""}`}
            >
              {c.short}
            </a>
          );
        })}
      </div>
    </nav>
  );
}
